import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './Redux/store';
import { Provider } from 'react-redux';
import axios from 'axios';
axios.defaults.baseURL='https://idealtsa.herokuapp.com/';

const rootElement = ReactDOM.createRoot(document.getElementById('root'));
rootElement.render(
    /// Index.js file Changing
    <Provider store={store}>
        <App />
    </Provider>
  
);
